<template>
  <div>
    <base-dialog :show="true" small>
      <!-- <div class="flex justify-center">
        <font-awesome-icon
          :style="{ color: '#eed202' }"
          icon="exclamation-triangle"
          class="warning-icon"
        />
      </div> -->
      <div class="grid grid-cols-12 gap-x-3">
        <h2 class="text-white text-center my-8 col-span-12">
          ต้องการออกจากระบบ?
        </h2>
        <vs-button
          class="col-start-3 col-span-4"
          color="#ffffff"
          text-color="#8d9498"
          @click="goBackPage"
          >ยกเลิก</vs-button
        >
        <vs-button
          class="col-start-7 col-span-4"
          color="#15c1c3"
          @click="logout"
          >ยืนยัน</vs-button
        >
      </div>
    </base-dialog>
  </div>
</template>

<script>
export default {
  methods: {
    goBackPage() {
      this.$router.go(-1);
    },
    logout() {
      this.$store.dispatch("logout");
      this.$router.replace("/login");
    },
  },
  created() {
    // this.logout();
  },
};
</script>

<style scoped>
.warning-icon{
    width: 100px;
    height: auto;
}
</style>